import type { LocationDescriptor } from "history";
import { replace } from "react-router-redux";
import { useMount } from "react-use";
import { t } from "ttag";

import { NotFound } from "metabase/common/components/ErrorPages";
import { usePageTitle } from "metabase/hooks/use-page-title";
import { connect } from "metabase/redux";
import { refreshCurrentUser } from "metabase/redux/user";

type DispatchProps = {
  refreshCurrentUser: () => any;
  onChangeLocation: (location: LocationDescriptor) => void;
};

type Props = DispatchProps;

const mapDispatchToProps = {
  refreshCurrentUser,
  onChangeLocation: replace,
};

const NotFoundFallbackPageInner = ({
  refreshCurrentUser,
  onChangeLocation,
}: Props) => {
  // Set here, on the route-level wrapper, rather than in the shared
  // `NotFound` component itself, since that component is also reused
  // inline in non-page contexts where it shouldn't own the page title.
  usePageTitle(t`Page not found`, { titleIndex: 1 });

  useMount(() => {
    async function refresh() {
      const result = await refreshCurrentUser();
      const isSignedIn = !result.error;
      if (!isSignedIn) {
        onChangeLocation("/auth/login");
      }
    }
    refresh();
  });

  return <NotFound />;
};

export const NotFoundFallbackPage = connect(
  null,
  mapDispatchToProps,
)(NotFoundFallbackPageInner);
